// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT!
/* tslint:disable */
export const APP_VERSION = '4.2.0';
export const APP_NAME = 'ibm-angular-mlrp';
export const FILE_HASH = '1732270266657';
export const BUILD_DATE = '2024-11-22T10:11:06.657Z';
/* tslint:enable */
